import { ExportOptionKey } from 'src-ironside/enums/resource.enum';
import * as JSZip from 'jszip';

export const EXPORT_OPTIONS = [
    {
        key: 'CATALOGUE',
        label: 'CATALOGUE',
        isDisable: true,
        quantity: 0,
        permission: true,
        type: 'PDF',
        //description: 'PDF với tất cả thông tin, không bao gồm biến logistic',
    },
    {
        key: 'CATALOGUE_NO_PRICE',
        label: 'CATALOGUE_NO_PRICE',
        isDisable: true,
        quantity: 0,
        permission: true,
        type: 'PDF',
        //description: 'PDF với tất cả thông tin, không gồm logistic và giá',
    },
    {
        key: 'CATALOGUE_DATA_SHEET',
        label: 'CATALOGUE_DATA_SHEET',
        isDisable: true,
        quantity: 0,
        permission: true,
        type: 'PDF',
        //description: 'PDF gồm cả thông tin logistic',
    },
    {
        key: 'PRICE',
        label: 'PRICE',
        isDisable: true,
        quantity: 0,
        permission: true,
        type: 'EXCEL',
        //description: 'Xuất giá dưới dạng Excel',
    },
    {
        key: 'LOGISTIC_DATA',
        label: 'LOGISTIC_DATA',
        isDisable: true,
        quantity: 0,
        permission: true,
        type: 'EXCEL',
        //description: 'Xuất thông tin logistic dưới dạng Excel',
    },
    {
        key: 'PHOTO',
        label: 'PRODUCT_IMAGES_HD',
        isDisable: false,
        quantity: 0,
        permission: true,
        type: 'IMAGE',
        //description: 'Ảnh sản phẩm độ phân giải cao',
    },
    {
        key: 'PHOTO_THUMBNAIL',
        label: 'PRODUCT_IMAGES_BD',
        isDisable: false,
        quantity: 0,
        permission: true,
        type: 'IMAGE',
        //description: 'Ảnh sản phẩm độ phân giải thấp',
    },
    {
        key: 'PI_COM',
        label: 'COMM_INFORMATION',
        isDisable: false,
        quantity: 0,
        permission: true,
        type: 'IMAGE',
        //description: 'Tài nguyên dạng "Information Commerciale"',
    },
    {
        key: 'TI_CER',
        label: 'CERTIFICATES_USINE',
        isDisable: false,
        quantity: 0,
        permission: true,
        type: 'IMAGE',
        //description: 'Tài nguyên "Factory certificates"',
    },
    {
        key: 'SOCIAL',
        label: 'CERTIFICATES_SOCIAL',
        isDisable: false,
        quantity: 0,
        permission: true,
        type: 'IMAGE',
        //description: 'Tài nguyên "Factory certificates"',
    },
    {
        key: 'TI_CER_IR',
        label: 'CERTIFICATES_IRONSIDE',
        isDisable: false,
        quantity: 0,
        permission: true,
        type: 'IMAGE',
        //description: 'Tài nguyên "Ironside Certificates"',
    },
    {
        key: 'TI_VIEW',
        label: 'EXPLODED_VIEW',
        isDisable: false,
        quantity: 0,
        permission: true,
        type: 'IMAGE',
        //description: 'Tài nguyên "Exploding view"',
    },
    {
        key: 'PI_MAN',
        label: 'INSTRUCTION_MANUAL',
        isDisable: false,
        quantity: 0,
        permission: true,
        type: 'IMAGE',
        //description: 'Tài nguyên "Instruction manual"',
    },
    {
        key: 'TI_PART',
        label: 'SPARE_PART',
        isDisable: false,
        quantity: 0,
        permission: true,
        type: 'IMAGE',
        //description: 'Tài nguyên "Spare parts list"',
    },
    {
        key: 'TI_ARTW',
        label: 'ARTWORKS',
        isDisable: false,
        quantity: 0,
        permission: true,
        type: 'IMAGE',
        //description: 'Tài nguyên "Artworks"',
    },
];

export const functionToExportKey: { [key: string]: ExportOptionKey } = {
    'export-catalogue-avec-prix': ExportOptionKey.CATALOGUE,
    'export-catalogue-sans-prix': ExportOptionKey.CATALOGUE_NO_PRICE,
    'export-catalogue-logistique': ExportOptionKey.CATALOGUE_DATA_SHEET,
    'export-excel-prix': ExportOptionKey.PRICE,
    'export-excel-logistique': ExportOptionKey.LOGISTIC_DATA,
    'export-photos-hd': ExportOptionKey.PHOTO,
    'export-photos-bd': ExportOptionKey.PHOTO_THUMBNAIL,
    'export-informations-commerciales': ExportOptionKey.PI_COM,
    'export-certificats-sociaux': ExportOptionKey.SOCIAL,
    'export-certificat-usine': ExportOptionKey.TI_CER,
    'export-certificat-ironside': ExportOptionKey.TI_CER_IR,
    'export-vues-eclatees': ExportOptionKey.TI_VIEW,
    'export-instruction-manual': ExportOptionKey.PI_MAN,
    'export-ressource-pieces-detachees': ExportOptionKey.TI_PART,
    'export-oeuvres-art': ExportOptionKey.TI_ARTW,
};

export const TEMPLATE_EXPORT_TYPES = [
    'CATALOGUE',
    'CATALOGUE_NO_PRICE',
    'CATALOGUE_DATA_SHEET',
    'PRICE',
    'LOGISTIC_DATA',
];

export const typeExport = [
    { label: 'CSV', value: 'csv' },
    { label: 'XLS', value: 'xls' },
    { label: 'XLSX', value: 'xlsx' },
];

export const options = [
    { label: 5, value: 5 },
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 120, value: 120 },
];

/**
 * Export photos (ZIP streamé) : un timeout back/proxy ou une coupure réseau signifie
 * en pratique que l'export est trop volumineux
 */
export const photoExportErrorMessage = (error: any): { key: string; params?: object } =>
    [0, 408, 502, 503, 504].includes(error?.status)
        ? { key: 'export.EXPORT_TOO_LARGE' }
        : { key: 'export.DOWNLOAD_ERROR', params: { item: 'PHOTO' } };

/**
 * Timeout back pendant le stream : le statut 200 est déjà parti et le ZIP arrive tronqué.
 * Un ZIP illisible est rejeté comme une coupure réseau (status 0 => EXPORT_TOO_LARGE).
 */
export const checkPhotoZip = (blob: Blob): Promise<Blob> =>
    JSZip.loadAsync(blob).then(
        () => blob,
        () => Promise.reject({ status: 0 }),
    );
